/* © CNES */
import { createContext, useMemo, useReducer } from 'react';
import { FilterInitValues } from '../models/constants/Filter';
import { ItemFilter } from '../models/Filter';

/**
 * FilterType
 */
export type FilterType = {
  filterData: ItemFilter;
  setFilterData: (filterItem: ItemFilter) => void;
  selectedMissions: number[] | null;
  setSelectedMissions: (missions: number[] | null) => void;
};
const initialState = {
  filterData: {
    ...FilterInitValues,
  },
  selectedMissions: null as number[] | null,
};

/**
 * actions
 */
const actions = {
  SET_FILTER_DATA: 'SET_FILTER_DATA',
  SET_SELECTED_MISSIONS: 'SET_SELECTED_MISSIONS',
};

/**
 * reducer
 * @param state state
 * @param action action
 * @returns state
 */
const reducer = (state: any, action: any) => {
  switch (action.type) {
    case actions.SET_FILTER_DATA:
      return {
        ...state,
        filterData: action.filterData,
      };
    case actions.SET_SELECTED_MISSIONS:
      return {
        ...state,
        selectedMissions: action.selectedMissions,
      };
    default:
      return state;
  }
};

/**
 * FilterData Context.
 */
export const FilterDataContext = createContext({} as FilterType);
/**
 * Filter Data Context Provider.
 */
export const FilterDataContextProvider = ({ children }: { children: any }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const contextValue = useMemo(() => {
    return {
      filterData: state.filterData,
      setFilterData: (filterItem: ItemFilter) => {
        dispatch({
          type: actions.SET_FILTER_DATA,
          filterData: { ...state.filterData, ...filterItem },
        });
      },
      selectedMissions: state.selectedMissions,
      setSelectedMissions: (missions: number[] | null) => {
        dispatch({
          type: actions.SET_SELECTED_MISSIONS,
          selectedMissions: missions,
        });
      },
    };
  }, [state.filterData, state.selectedMissions]);

  return (
    <FilterDataContext.Provider value={contextValue}>
      {children}
    </FilterDataContext.Provider>
  );
};
